export default __webpack_public_path__ + "static/media/alert.4fc346e9.svg";